module.exports = __webpack_public_path__ + "static/media/seminar-image.e7f84799.webp";